import * as React from 'react'
import TenantManagementGrid from "../../components/bo-core/grids/TenantManegementGrid/TanantManagementGrid";

const TenantManagement = () => {
    return (
        <div style={{backgroundColor: '#2D3436', height: '100%'}}>
            <TenantManagementGrid/>
        </div>
    )
}
export default TenantManagement;


// WEBPACK FOOTER //
// ./app/views/bo-core/TenantManagemet.tsx